module.exports = __webpack_public_path__ + "d0378409aea785c66292bd5865c4d9b2.svg";